import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { ASSETS_PATH } from 'src/app/core/config';
import { UpdateUserBasicInfoModel, UserBasicInfo } from 'src/app/core/models/user.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { FileService } from 'src/app/core/services/file.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-update-my-basic-information',
  templateUrl: './update-my-basic-information.component.html',
  styleUrls: ['./update-my-basic-information.component.scss']
})
export class UpdateMyBasicInformationComponent implements OnInit {
  userBasicInfo = new UserBasicInfo();
  updateModel = new UpdateUserBasicInfoModel();
  updateMyUserForm: FormGroup;
  assetsPath = ASSETS_PATH;
  cities = [];
  isImage = false;

  constructor(private authService: AuthService,
    private alertService: AlertService,
    private userService: UserService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    private router: Router,
    private fileService: FileService) { }

  ngOnInit(): void {
    this.updateMyUserForm = this.formBuilder.group({
      // fullName: new FormControl('', [
      //   Validators.required,
      //   Validators.minLength(5),
      //   Validators.maxLength(100)
      // ]),
      phone: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10)
      ]),
      primaryCityId: new FormControl('', [
        Validators.required
      ]),
      secondaryCityId: new FormControl('')
    });
    this.loadingService.setLoading(true);
    this.userService.getUserBasicInfo().subscribe(response => {
      if (response.success) {
        this.userBasicInfo = response;
        if (this.userBasicInfo.image !== null && this.userBasicInfo.image !== ""){
          this.isImage = true;
        }
        this.updateModel.image = this.userBasicInfo.image;
        // this.updateMyUserForm.controls['fullName'].setValue(this.userBasicInfo.displayName);
        this.updateMyUserForm.controls['phone'].setValue(this.userBasicInfo.phone);
        this.updateMyUserForm.controls['primaryCityId'].setValue(this.userBasicInfo.primaryCityId);
        this.updateMyUserForm.controls['secondaryCityId'].setValue(this.userBasicInfo.secondaryCityId);
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      });
    this.getCities();


  }

  async getCities() {
    const data: any = await this.authService.getUserToken().toPromise();
    this.authService.getCitySelectList(data.token).subscribe(response => {
      if (response.success) {
        this.cities = response.cities;
      }
    });
  }

  get f() {
    return this.updateMyUserForm.controls;
  }

  update() {
    if (this.updateMyUserForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen bilgilerinizi doğru bir şekilde giriniz!', 'error');
      return;
    }
    if (this.updateMyUserForm.valid) {
      let dataObj = Object.assign({}, this.updateMyUserForm.value);
      this.updateModel.phone = dataObj.phone;
      this.updateModel.primaryCityId = dataObj.primaryCityId;
      this.updateModel.secondaryCityId = dataObj.secondaryCityId;
      this.loadingService.setLoading(true);
      this.userService.updateMyProfile(this.updateModel).subscribe(response => {
        if (response.success) {
          this.alertService.alert('Başarılı', '', 'success');
          this.router.navigate(['/update-my-basic-information']);
        } else {
          this.alertService.alert('Hata!', response.errors[0], 'error');
        }
        this.loadingService.setLoading(false);
      }, (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      })
    }
  }

  onLocalFileChange(files: NgxFileDropEntry[]) {
    this.loadingService.setLoading(true);
    for (const f of files) {
      const fileEntry = f.fileEntry as FileSystemFileEntry;
      if (fileEntry.isFile && this.isFileAllowed(fileEntry.name)) {
        fileEntry.file((file) => {
          this.fileService.uploadFile(file).subscribe(res => {
            if (res.success) {
              this.updateModel.image = res.fileName;
            }
            this.loadingService.setLoading(false);
          });
        })
      } else {
        this.alertService.alert('Hata!', "Lütfen jpg, png veya jpeg uzantılı bir resim dosyası yükleyiniz!", 'error');
        this.loadingService.setLoading(false);
      }
    }
  }
  removeFile() {
    this.updateModel.image = null;
  }

  isFileAllowed(fileName: string) {
    let isFileAllowed = false;
    const allowedFiles = ['.jpg', '.png', '.jpeg'];
    const regex = /(?:\.([^.]+))?$/;
    const extension = regex.exec(fileName);
    if (undefined !== extension && null !== extension) {
        for (const ext of allowedFiles) {
            if (ext === extension[0]) {
                isFileAllowed = true;
            }
        }
    }
    return isFileAllowed;
}

}
